import { render, staticRenderFns } from "./mhcostdashboard.vue?vue&type=template&id=6fe79a9a&"
import script from "./mhcostdashboard.vue?vue&type=script&lang=ts&"
export * from "./mhcostdashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports